/**
 * Favoritos de Caboki. Nativo, progresivo y PRIVADO DEL NAVEGADOR: sin cuenta, sin app y sin
 * tracking. Nada sale de este dispositivo.
 *
 * SE GUARDAN HANDLES, NO PRODUCTOS. Es lo que valida HIVE y no es un detalle: guardando solo el
 * handle, la pagina de favoritos pide el producto a Shopify y pinta imagen, precio y disponibilidad
 * ACTUALES. El problema de los precios obsoletos no se parchea: no llega a existir.
 *
 * Los tres problemas que HIVE avisa, resueltos a proposito:
 *   · Dos pestañas que se pisan  -> se escucha `storage` y la otra pestaña se repinta sola.
 *   · Almacen corrupto           -> toda lectura en try/catch y validando que sea un array de
 *                                   cadenas; si no lo es, se descarta y se empieza limpio.
 *   · Precios obsoletos          -> no se guardan precios.
 *
 * Y si `localStorage` no esta disponible o falla a mitad, NADA revienta: se baja a `sessionStorage`
 * -privado de la pestaña, no viaja al servidor, no es cookie y no rastrea- y solo si tampoco ese
 * funciona se queda la memoria del documento. En ese ultimo caso la pagina DEJA DE PROMETER que se
 * guardan, porque no sobrevivirian al cambio de pagina.
 */
(function () {
  'use strict';

  var CLAVE = 'caboki:favoritos:v1';

  /**
   * TRES NIVELES DE ALMACEN, y no es una floritura: los pide un fallo real.
   *
   *   1. localStorage   — persiste entre visitas. Lo normal.
   *   2. sessionStorage — persiste al NAVEGAR y al recargar dentro de la pestaña.
   *   3. memoria        — solo dentro de este documento. Ultimo recurso.
   *
   * La segunda revision cruzada encontro que mi respaldo anterior era SOLO memoria, y la memoria
   * muere al cambiar de pagina: si `setItem` fallaba en la ficha, al llegar a /pages/favoritos el
   * favorito habia desaparecido. Guardar bien y perderlo al pasar de pagina es peor que no guardar,
   * porque el usuario cree que lo tiene.
   *
   * `sessionStorage` es el respaldo correcto: es privado de la pestaña, no viaja al servidor, no es
   * una cookie y no rastrea nada. Y sobrevive justo a lo que hacia falta.
   */
  var enMemoria = null;

  function usable(almacen) {
    try {
      var t = '__cb__';
      almacen.setItem(t, t);
      almacen.removeItem(t);
      return true;
    } catch (e) {
      return false;
    }
  }

  function local() { try { return window.localStorage; } catch (e) { return null; } }
  function sesion() { try { return window.sessionStorage; } catch (e) { return null; } }

  var HAY_LOCAL = !!local() && usable(local());
  var HAY_SESION = !!sesion() && usable(sesion());

  /**
   * Se marcan cuando una ESCRITURA falla pese a que el almacen habia pasado el sondeo inicial.
   *
   * SESION_DEGRADADO existe por el mismo motivo que su hermano y lo encontro la tercera revision
   * cruzada: yo marcaba la degradacion de localStorage pero NO la de sessionStorage, asi que si la
   * sesion pasaba el sondeo y luego reventaba al escribir, `fuente()` seguia diciendo «sesion» y
   * `leer()` iba a buscar ahi un valor que nunca llego a guardarse, ignorando la memoria.
   * Es el mismo fallo de la primera remediacion, una capa mas abajo.
   */
  var LOCAL_DEGRADADO = false;
  var SESION_DEGRADADO = false;

  /** ¿La sesion ya tiene la lista? Solo se escribe ahi cuando localStorage fallo, asi que MANDA. */
  function sesionMandaAqui() {
    if (!HAY_SESION) return false;
    try { return sesion().getItem(CLAVE) !== null; } catch (e) { return false; }
  }

  /**
   * La fuente efectiva: una sola, y la misma para leer y escribir. Sin esto, leer de un sitio y
   * escribir en otro es exactamente el fallo que se acaba de corregir.
   */
  function fuente() {
    // Primero de todo: una sesion que ya no admite escrituras NO es fuente fiable, tenga o no la
    // clave dentro. Devolveria un valor viejo y desharia lo que el usuario acaba de hacer.
    if (SESION_DEGRADADO) return 'memoria';
    if (sesionMandaAqui()) return 'sesion';
    if (HAY_LOCAL && !LOCAL_DEGRADADO) return 'local';
    if (HAY_SESION) return 'sesion';
    return 'memoria';
  }

  function limpiaLista(datos) {
    if (!Array.isArray(datos)) return [];
    var limpio = [];
    for (var i = 0; i < datos.length; i++) {
      var h = datos[i];
      if (typeof h === 'string' && h.length > 0 && h.length < 200 && limpio.indexOf(h) === -1) {
        limpio.push(h);
      }
    }
    return limpio;
  }

  /** Lee la lista. Ante cualquier duda devuelve [] en vez de romper la pagina. */
  function leer() {
    var f = fuente();
    if (f === 'memoria') return enMemoria ? enMemoria.slice() : [];
    try {
      var almacen = f === 'sesion' ? sesion() : local();
      var crudo = almacen.getItem(CLAVE);
      if (!crudo) return [];
      // Un almacen manipulado no debe llegar al DOM.
      return limpiaLista(JSON.parse(crudo));
    } catch (e) {
      return [];
    }
  }

  function escribir(lista) {
    var texto = JSON.stringify(lista);
    enMemoria = lista.slice(); // la memoria se mantiene siempre al dia como ultimo recurso

    if (!sesionMandaAqui() && HAY_LOCAL && !LOCAL_DEGRADADO) {
      try { local().setItem(CLAVE, texto); return; }
      catch (e) { LOCAL_DEGRADADO = true; } // cuota llena o bloqueo sobrevenido
    }
    if (HAY_SESION && !SESION_DEGRADADO) {
      try { sesion().setItem(CLAVE, texto); return; }
      catch (e) { SESION_DEGRADADO = true; } // igual que el local: sin marcarlo, leer() volveria ahi
    }
    // Ni local ni sesion: solo memoria, y quien pinta la pagina debe DEJAR DE PROMETER persistencia.
  }

  function tiene(handle) { return leer().indexOf(handle) !== -1; }

  function alternar(handle) {
    var lista = leer();
    var i = lista.indexOf(handle);
    if (i === -1) lista.push(handle); else lista.splice(i, 1);
    escribir(lista);
    avisar();
    return i === -1; // true = ha quedado guardado
  }

  function quitar(handle) {
    var lista = leer();
    var i = lista.indexOf(handle);
    if (i !== -1) { lista.splice(i, 1); escribir(lista); avisar(); }
  }

  function avisar() {
    document.dispatchEvent(new CustomEvent('caboki:favoritos:cambio', { detail: { lista: leer() } }));
  }

  /** Anuncia a lectores de pantalla. Sin esto, guardar es invisible para quien no ve el corazon. */
  function anunciar(texto) {
    var region = document.getElementById('cb-fav-anuncio');
    if (!region || !texto) return;
    region.textContent = '';
    // El cambio de texto tiene que ser perceptible como cambio, no como contenido inicial.
    window.setTimeout(function () { region.textContent = texto; }, 60);
  }

  /** Pone cada boton en su estado real. Se llama al cargar y en cada cambio, incluso de otra pestaña. */
  function pintarBotones(raiz) {
    var ambito = raiz || document;
    var botones = ambito.querySelectorAll('[data-cb-fav]');
    for (var i = 0; i < botones.length; i++) {
      var b = botones[i];
      var guardado = tiene(b.getAttribute('data-cb-fav'));
      b.setAttribute('aria-pressed', guardado ? 'true' : 'false');
      b.classList.toggle('cb-fav--on', guardado);
      var etiqueta = guardado ? b.getAttribute('data-cb-fav-quitar') : b.getAttribute('data-cb-fav-guardar');
      if (etiqueta) b.setAttribute('aria-label', etiqueta);
    }
  }

  document.addEventListener('click', function (ev) {
    var boton = ev.target.closest ? ev.target.closest('[data-cb-fav]') : null;
    if (!boton) return;
    ev.preventDefault();
    var handle = boton.getAttribute('data-cb-fav');
    if (!handle) return;
    var guardado = alternar(handle);
    pintarBotones();
    anunciar(guardado ? boton.getAttribute('data-cb-fav-aviso-on') : boton.getAttribute('data-cb-fav-aviso-off'));
  });

  // Otra pestaña ha tocado la lista: esta se repinta sola en vez de mostrar un estado mentiroso.
  window.addEventListener('storage', function (ev) {
    if (ev.key === CLAVE) { pintarBotones(); avisar(); }
  });

  document.addEventListener('DOMContentLoaded', function () { pintarBotones(); });
  if (document.readyState !== 'loading') pintarBotones();

  /**
   * `fuente()` se expone porque la pagina necesita saberlo para NO PROMETER lo que no puede cumplir:
   * si solo queda memoria, los favoritos no sobreviven al cambio de pagina, y decir «se guardan en
   * este navegador» seria falso para ese visitante.
   */
  window.CabokiFavoritos = {
    leer: leer, tiene: tiene, quitar: quitar,
    pintarBotones: pintarBotones, anunciar: anunciar,
    fuente: fuente
  };
})();
